declare global {
  interface Window {
    FansAudioPlayer: any;
  }
}

// Cache-bust token generated once per page load.
const PLAYER_LIB_VERSION = String(Date.now());

export function loadFansAudioPlayerResources(): Promise<void> {
  if (typeof document === 'undefined') {
    return Promise.resolve();
  }

  if (!document.querySelector('link[href*="font-awesome"]')) {
    const fa = document.createElement('link');
    fa.rel = 'stylesheet';
    fa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    document.head.appendChild(fa);
  }

  if (!document.querySelector('link[data-fap-css]')) {
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = `/lib/fans-audio-player/fans-audio-player.css?t=${PLAYER_LIB_VERSION}`;
    css.setAttribute('data-fap-css', '1');
    document.head.appendChild(css);
  }

  if (window.FansAudioPlayer) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const existing = document.querySelector('script[data-fap-js]');
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true });
      if (window.FansAudioPlayer) resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `/lib/fans-audio-player/fans-audio-player.js?t=${PLAYER_LIB_VERSION}`;
    script.setAttribute('data-fap-js', '1');
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
}
